module.exports = __webpack_public_path__ + "img/logo_transparent.9d3f9e62.png";